import Vue from 'vue';
import moment from 'moment';

require('moment/locale/hu');
Vue.use(require('vue-moment'), {
  moment
});
Vue.prototype.moment = moment;
